import { Decimal, type DecimalValue } from './decimal';

/** عدد المنازل العشرية لكل المبالغ المالية (Decimal(12,2)) */
export const MONEY_DP = 2;

/** صفر مالي */
export const ZERO = new Decimal(0);

/** تحويل أي قيمة إلى Decimal بلا تقريب */
export function D(value: DecimalValue): Decimal {
  return value instanceof Decimal ? value : new Decimal(value);
}

/**
 * تقريب مبلغ مالي إلى منزلتين — ROUND_HALF_UP.
 * يُستدعى فقط عند إخراج قيمة نهائية للتخزين أو العرض، لا في وسط العمليات.
 */
export function toMoney(value: DecimalValue): Decimal {
  return D(value).toDecimalPlaces(MONEY_DP, Decimal.ROUND_HALF_UP);
}

/** حصر المبلغ في حدود Decimal(12,2): 10 خانات صحيحة + 2 عشرية */
export const MONEY_MAX = new Decimal('9999999999.99');

/** هل المبلغ داخل الحدود المسموح بها في قاعدة البيانات؟ */
export function isMoneyInRange(value: DecimalValue): boolean {
  const v = D(value).abs();
  return v.isFinite() && v.lte(MONEY_MAX);
}

/** مجموع دقيق لقائمة مبالغ */
export function sum(values: Iterable<DecimalValue>): Decimal {
  let acc = new Decimal(0);
  for (const v of values) acc = acc.plus(D(v));
  return acc;
}

/** تمثيل نصي قياسي بمنزلتين — للتخزين والعرض في CSV */
export function moneyToString(value: DecimalValue): string {
  return toMoney(value).toFixed(MONEY_DP);
}

/** تمثيل رقمي — للـ JSON فقط، لا يُستخدم في أي حساب */
export function moneyToNumber(value: DecimalValue): number {
  return toMoney(value).toNumber();
}

/** هل القيمة صفر مالياً (بعد التقريب)؟ */
export function isZeroMoney(value: DecimalValue): boolean {
  return toMoney(value).isZero();
}

/** حماية من NaN / Infinity القادمة من مدخلات غير متحقَّق منها */
export function sanitize(value: DecimalValue, fallback: DecimalValue = 0): Decimal {
  const d = D(value);
  return d.isFinite() ? d : D(fallback);
}
